/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function PublishedFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="published_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="published"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="published_filter"
        label={intl.formatMessage({
          id: 'published',
          defaultMessage: 'Publié'
        })}
        name="published"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="unpublished_filter"
        label={intl.formatMessage({
          id: 'unpublished',
          defaultMessage: 'Non publié'
        })}
        name="published"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default PublishedFilter
